<div class="root">
  <div class="container">
    <div class="content">
      <ng-container *ngIf="isLoading">
        <div class="loading-placeholder-container">
          <app-loading-placeholder></app-loading-placeholder>
        </div>
      </ng-container>

      <ng-container *ngIf="!isLoading">
        <ng-container *ngIf="isDesktop">
          <ng-container *ngFor="let item of breadcrumbMenuData.breadcrumbs">
            <a class="text link" [routerLink]="[item.url]">{{ item.label }}</a>

            <div class="arrow">
              <app-lucide-icon [iconName]="'chevron-right'" [color]="'disabled'"></app-lucide-icon>
            </div>
          </ng-container>

          <span class="text">{{ breadcrumbMenuData.currentBreadcrumb.label }}</span>
        </ng-container>

        <ng-container *ngIf="!isDesktop">
          <a class="text link" [routerLink]="[breadcrumbMenuData.mobileBreadcrumb.url]">{{
            breadcrumbMenuData.mobileBreadcrumb.label
          }}</a>
        </ng-container>
      </ng-container>
    </div>
  </div>
</div>
